window.jQuery = window.$ = require('jquery');
var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('client/main'));
    processInclude(require('./s3/awss3midleware'));
});

